/** @jsx jsx */
import { jsx } from 'theme-ui';
import SectionNav from '../section-nav/section-nav';

const PageSectionContainer = (props) => (
  <div
    sx={{
      flexBasis: [null, null, '80%'],
    }}
    {...props}
  />
);

export const PageNavContainer = ({ children, ...props }) => (
  <div
    sx={{
      display: 'flex',
    }}
    {...props}
  >
    <SectionNav />
    <PageSectionContainer>
      {children}
    </PageSectionContainer>
  </div>
);
